module.exports = __webpack_public_path__ + "static/media/DSCN0350.536b2ca1.jpg";